// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2IIws","name":"ConsentHeader_name__1vaX4","birthday":"ConsentHeader_birthday__3dJF0","skeleton":"ConsentHeader_skeleton__3tgNi"};